/* MB - Formato de precios chileno: punto separador de miles */
(function() {
  function formatearPreciosChilenos() {
    var selectores = [
      '.f-price-item',
      '.f-price-item--sale',
      '.f-price-item--regular',
      '.money',
      '[data-product-price]',
      '.cart-item__price',
      '.cart-subtotal__price'
    ];
    var elementos = document.querySelectorAll(selectores.join(','));
    elementos.forEach(function(el) {
      var texto = el.textContent || el.innerText;
      // Solo actuar si el precio tiene coma (formato anglosajón: $79,990)
      // No tocar si ya tiene punto como separador (formato chileno: $79.990)
      if (!texto.match(/\$[\d,]+,\d{3}/)) return;
      var nuevo = texto.replace(/\$([\d,]+)(?:\.\d+)?(\s*CLP)?/g, function(match, numStr, sufijo) {
        // Verificar que tiene coma antes de procesar
        if (numStr.indexOf(',') === -1) return match;
        var numero = parseInt(numStr.replace(/,/g, ''), 10);
        if (isNaN(numero)) return match;
        var formateado = numero.toLocaleString('es-CL');
        return '$' + formateado + (sufijo ? sufijo : '');
      });
      if (nuevo !== texto) {
        el.textContent = nuevo;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    formatearPreciosChilenos();
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.addedNodes.length > 0) {
          setTimeout(formatearPreciosChilenos, 80);
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
